// src/components/sections/PortfolioSection.js
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { fetchFeaturedPortfolio } from '../../services/api';
import { useLang } from '../../i18n/LanguageContext';
import { SkeletonGrid, SectionHeader, ErrorBox } from '../ui';
import PortfolioCard from '../ui/PortfolioCard';
import styles from './PortfolioSection.module.css';

export default function PortfolioSection() {
  const { ui } = useLang();
  const { data: items = [], isLoading, isError, refetch } = useQuery(
    'featuredPortfolio',
    fetchFeaturedPortfolio,
    { staleTime: 1000 * 60 * 5 }
  );

  return (
    <section className={styles.section} id="portfolio">
      <SectionHeader
        badge={ui('✦ نمونه‌کارها', '✦ Portfolio')}
        title={ui('گالری شمع‌های کیوت کندل', 'Cute Candels Gallery')}
      />

      {isLoading && <SkeletonGrid count={6} height={280} />}
      {isError && <ErrorBox onRetry={refetch} />}
      {!isLoading && !isError && (
        <>
          <div className={styles.grid}>
            {items.map((item) => (
              <PortfolioCard key={item.id} item={item} />
            ))}
          </div>
          <div className={styles.more}>
            <Link to="/portfolio" className="btn-secondary">
              {ui('مشاهده همه نمونه‌کارها ←', 'View All Portfolio ←')}
            </Link>
          </div>
        </>
      )}
    </section>
  );
}
